import { cmsColorClass } from '@/utils/cmsColorClass';

const Block = ({settings, name, id: idProp, position, className = "", children}) => {
  const id = idProp ?? (position !== undefined ? `${name}_${position}` : name);
    const blockTopPadding =
        settings?.block_top_padding === 'Default' ? 'pt-12 md:pt-14 lg:pt-16' :
        settings?.block_top_padding === 'Zero' ? 'pt-0' :
        settings?.block_top_padding === 'Small' ? 'pt-4 md:pt-6 lg:pt-8' :
        settings?.block_top_padding === 'Medium' ? 'pt-8 md:pt-10 lg:pt-12' :
        settings?.block_top_padding === 'Large' ? 'pt-16 md:pt-18 lg:pt-20' : 'pt-12 md:pt-14 lg:pt-16';
    const blockBottomPadding =
        settings?.block_bottom_padding === 'Default' ? 'pb-12 md:pb-14 lg:pb-16' :
        settings?.block_bottom_padding === 'Zero' ? 'pb-0' :
        settings?.block_bottom_padding === 'Small' ? 'pb-4 md:pb-6 lg:pb-8' :
        settings?.block_bottom_padding === 'Medium' ? 'pb-8 md:pb-10 lg:pb-12' :
        settings?.block_bottom_padding === 'Large' ? 'pb-16 md:pb-18 lg:pb-20' : 'pb-12 md:pb-14 lg:pb-16';

    return (
        <div id={id} data-name={name} className={`relative flow-root ${blockTopPadding} ${blockBottomPadding} ${cmsColorClass(settings?.background_color?.color_selector, "bg-warm-white")} ${cmsColorClass(settings?.text_color?.color_selector, "text-black")} ${className}`}>
            {children}
        </div>
    )
}

export default Block;